import { api, ApiError } from "@/api/api";
import { CreateStoryConfig, StoryConfig } from "@/api/story-configs-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Variables = {
  data: CreateStoryConfig;
};

export function useCreateStoryConfig() {
  const queryClient = useQueryClient();
  return useMutation<StoryConfig, ApiError, Variables>({
    mutationKey: ["POST", "storyConfigs"],
    mutationFn: (variables) =>
      api.storyConfigs.post(variables.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET", "storyConfigs"] });
    }
  });
}
